import React, { useState } from "react";
import MessagePicker from "../../../Components/MessagePicker";
import { TLogAction } from "./types";
import { useTranslation } from "react-i18next";

interface ILogActionFormProps {
  action: TLogAction;
  onChange: (logAction: TLogAction) => void;
}

const LogActionForm = (props: ILogActionFormProps) => {
  const { action, onChange } = props;
  const [logAction, setLogAction] = useState<TLogAction>(action);
  const { t } = useTranslation();

  const updateLogAction = (newLogAction: TLogAction) => {
    setLogAction(newLogAction);
    onChange(newLogAction);
  };

  return (
    <>
      <MessagePicker
        fullWidth
        label={t("Message")}
        title={t(logAction.title)}
        text={t(logAction.text)}
        onMessageChange={(title: string, text: string) => {
          updateLogAction({ ...logAction, title: title, text: text });
        }}
        data-cy="log-action-message-picker"
      />
    </>
  );
};

export default LogActionForm;
